﻿import { LiveDataSet, LiveDataSetValue, Status } from "../../API/LiveData/LiveDataSet";
import { ILiveDataListener } from "../../ILiveDataListener";
import { ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { WaveSpectrum, WaveSpectrumComponent } from "../../ValueTypes/WaveSpectrum";
import { ISiteObservationsPage } from "./ISiteObservationsPage";

export class WaveSpectrumChart implements ILiveDataListener {

    private chart: JQuery;
    private stationId: string;

    constructor(page: ISiteObservationsPage, container: JQuery, top: number, left: number, height: number, width: number) {

        this.stationId = page.station.Station.Id;

        var box: JQuery = $('<div class="midi_SiteObservations_chart_container"></div>')
            .css('position', 'absolute')
            .css('top', top + '%')
            .css('left', left + '%')
            .css('height', height + '%')
            .css('width', width + '%');
        
        container.append(box);


        this.chart = $('<div></div>')
            .css('height', '100%')
            .appendTo(box);

        if (page.mainSite.liveDataManager.latestData) {
            this.redrawChart(page.mainSite.liveDataManager.latestData);
        }

    }

    public liveDataChanged(latestData: LiveDataSet): void {
        this.redrawChart(latestData);
    }

    private redrawChart(latestData: LiveDataSet): void {

        this.chart.empty();

        var spectrum: WaveSpectrum = null;
        if (latestData.Stations[this.stationId] && latestData.Stations[this.stationId].GroupValues[ParameterGroupInfoSet.WaveSpectrum.Id]) {

            var val: LiveDataSetValue = latestData.Stations[this.stationId].GroupValues[ParameterGroupInfoSet.WaveSpectrum.Id][0];

            if (val.ExpiryStatus === null || val.ExpiryStatus === Status.Expired) {
                this.chart.append($('<div class="midi_SiteObservations_chart_no_data">Wave Spectrum not available</div>'));
                return;
            }

            spectrum = <WaveSpectrum> val.Value;

        } else {
            this.chart.append($('<div class="midi_SiteObservations_chart_no_data">Wave Spectrum not available</div>'));
            return;
        }

        var minFreq: number;
        var maxFreq: number;

        var seriesOptions = [];

        var direction: boolean = false;

        spectrum.Components.forEach((component: WaveSpectrumComponent) => {

            var lowerBound: number = component.CentralFrequency - (0.5 * component.Width);
            var upperBound: number = component.CentralFrequency + (0.5 * component.Width);

            if (minFreq == null || maxFreq == null) {
                minFreq = lowerBound
                maxFreq = upperBound
            } else {
                minFreq = Math.min(minFreq, lowerBound);
                maxFreq = Math.max(maxFreq, upperBound);
            }

            seriesOptions.push({
                name: component.CentralFrequency + 'Hz',
                data: [[lowerBound, 0], [lowerBound, component.SpectralDensity], [upperBound, component.SpectralDensity], [upperBound, 0]],
                color: '#6BF',
                lineColor: '#FFF',
                lineWidth: 1,
                yAxis: 0 // always the spectral density axis
            });

            if (component.Direction) {
                direction = true;
                seriesOptions.push({
                    name: component.CentralFrequency + 'Hz - Direction',
                    data: [[component.CentralFrequency, component.Direction], [component.CentralFrequency, component.Direction]],
                    color: '#f00',
                    marker: {
                        enabled: true,
                        symbol: 'square'
                    },
                    yAxis: 1 // always the direction axis
                });
            }

            if (component.Spread && component.Direction) {
                seriesOptions.push({
                    name: component.CentralFrequency + 'Hz - Spread Max',
                    data: [[component.CentralFrequency, (component.Direction + (0.5 * component.Spread) + 360) % 360], [component.CentralFrequency, (component.Direction + (0.5 * component.Spread) + 360) % 360]],
                    color: '#f88',
                    marker: {
                        enabled: true,
                        symbol: 'triangle-down',
                        radius: 5
                    },
                    yAxis: 1 // always the direction axis
                });

                seriesOptions.push({
                    name: component.CentralFrequency + 'Hz - Spread Min',
                    data: [[component.CentralFrequency, (component.Direction - (0.5 * component.Spread) + 360) % 360], [component.CentralFrequency, (component.Direction - (0.5 * component.Spread) + 360) % 360]],
                    color: '#f88',
                    marker: {
                        enabled: true,
                        symbol: 'triangle',
                        radius: 5
                    },
                    yAxis: 1 // always the direction axis
                });


            }
        });

        var yAxisOptions = [];

        yAxisOptions.push(
            {
                min: 0,
                title: {
                    text: 'Spectral Density (m^2 / Hz)'
                }
            });

        if (direction) {
            yAxisOptions.push(
                {
                    min: 0,
                    max: 360,
                    title: {
                        text: 'Direction (degs)'
                    },
                    opposite: true,
                    tickInterval: 90,
                    minTickInterval: 90
                });
        }

        this.chart.highcharts({
            chart: {
                type: 'area',
                marginTop: 30
            },
            exporting: {
                enabled: false
            },
            title: {
                text: ''
            },
            xAxis: {
                min: minFreq,
                max: maxFreq + 0.05 - ((maxFreq + 0.05) % 0.05),
                title: {
                    text: 'Frequency (Hz)'
                },
                dateTimeLabelFormats: {
                    month: '%b'
                }
            },
            yAxis: yAxisOptions,
            legend: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                area: {
                    lineColor: '#036',
                    lineWidth: 1
                },
                series: {
                    animation: false,
                    events: {
                        legendItemClick: function () {
                            return false;
                        }
                    },
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                }
            },
            series: seriesOptions,
            credits: {
                enabled: false
            }
        });
    }
}